import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaArrowLeftLong } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { TiTick } from "react-icons/ti";
import { Link, useLocation } from 'react-router-dom';
import fav1 from "../../Image/favicon1.png";
import user from "../../Image/user.png";
import { BASE_URL } from '../../insightConfig/insightConfig';
import "../Reportcard/Reportcard.css";
import SectionWiseReport from '../CUET/Common/SectionWiseReport';


const UGC_Report = () => {
    const location = useLocation();
    const { state: { testDetails, reAttemptReport } } = useLocation();
    const [testReport, setTestReport] = useState({});
    const { orderId, testNumber, SubjectID, exam_type } = testDetails;
    const [sectionWiseReport, setSectionWiseReport] = useState([]);
    console.log(orderId, testNumber, SubjectID, exam_type);
    const storedAuthToken = localStorage.getItem('authtoken');
    const [reportAnserSheet, setReportAnserSheet] = useState([]);
    const [courseRecommendation, setCourseRecommendation] = useState(null);
    // const [correctAnswers, setCorrectAnswers] = useState(0);

    useEffect(() => {
        if (!orderId || !testNumber || !exam_type) {
            return
        }
        if (reAttemptReport) {
            setTestReport(reAttemptReport);
            const answerSheet = reAttemptReport?.answersheet;
            setReportAnserSheet(answerSheet);
            // setCorrectAnswers(answerSheet?.filter(item => item.selectedOption === item.correctOption).length);
            return;
        }
        axios.get(`${BASE_URL}/ugc/user/loadUGC_TestReport/${exam_type}/${orderId}/${testNumber}/${SubjectID ?? ''}`).then((response) => {
            setTestReport(response.data.data);
            setSectionWiseReport(response?.data?.sectionWiseReport || []);
            const answerSheet = JSON.parse(response.data.data.answersheet);
            setReportAnserSheet(answerSheet);
            // setCorrectAnswers(answerSheet?.filter(item => item.selectedOption === item.correctOption).length);
        }).catch((error) => {
            console.log(error)
        })
    }, []);

    // Fetch course recommendation based on student performance
    useEffect(() => {
        if (!testReport?.totalquestion) return;
        const studentScore = Number((testReport?.testcorrectmarks || 0) - (testReport?.testwrongmarks || 0)) || 0;
        const maxPossible = (testReport?.totalquestion || 1) * (testReport?.marks_per_question || 2);
        const studentPercent = maxPossible > 0 ? Math.max(0, Math.round((studentScore / maxPossible) * 100)) : 0;
        axios.get(`${BASE_URL}/ugc/user/courseRecommendation/${studentPercent}`)
            .then(res => { if (res?.data?.data) setCourseRecommendation(res.data.data); })
            .catch(err => console.log('Error fetching recommendation:', err));
    }, [testReport]);

    // const percentile = (correctAnswers / reportAnserSheet?.length) * 100 || 0;



    const renderhtml = (paragraphs) => {
        return <p className='renderhtml' dangerouslySetInnerHTML={{ __html: paragraphs }} />;
    };

    const selectedResponseIcon = (optionPosition, selectedOption, correctOption) => {
        if ((optionPosition == correctOption)) {
            if (selectedOption != '') {
                return <TiTick size={30} color='green' className='ms-2' />
            }

        } else {
            if (selectedOption == optionPosition && correctOption != selectedOption) {
                return <RxCross2 size={26} color='red' className='ms-2' />
            }
        }
    }
    let logo = 'https://insightdelhi.com/images/favicon.ico'
    // if (!testReport?.Sn) {
    //     return <h1>Raaz</h1>
    // }
    const getQuestionDifficulty = (accuracy) => {
        if (accuracy >= 90) {
            return " (Easy)";
        } else if (accuracy >= 60) {
            return " (Medium)";
        } else {
            return " (Hard)";
        }
    };
    return (
        <>
            <div className="container-fluid bg-light py-4" style={{ position: 'absolute', zIndex: "200", top: "0" }}>
                <div className="container">
                    <div className="row">

                        {/* Back Button */}
                        <div className="col-12 mb-3">
                            <div className="d-flex align-items-center p-2 px-3 rounded" style={{ backgroundImage: "linear-gradient(to right, rgb(155, 0, 0), rgb(109, 7, 97))" }}>
                                <Link to="/StudentDashboard" state={{ testData: testDetails, prePath: location.pathname }} className="text-white fs-4 text-decoration-none">
                                    <FaArrowLeftLong />
                                </Link>
                            </div>
                        </div>

                        {/* Header & Logo */}
                        <div className="col-12 text-center py-4" style={{ backgroundImage: "linear-gradient(to right, rgb(155, 0, 0), rgb(109, 7, 97))" }}>
                            <img src={logo} alt="Logo" onError={(e) => e.target.src = fav1} style={{ width: "110px" }} />
                            <h3 className="text-warning fw-bold border-bottom py-2">DETAILED PERFORMANCE REPORT</h3>
                            <p className="text-white fw-semibold">{testDetails?.Title}</p>
                        </div>

                        {/* Rank & Percentile */}
                        <div className="col-12 text-center py-3" style={{ backgroundImage: "linear-gradient(to right, #fff7b1, #c4f7f0)" }}>
                            <img src={user} alt="User" style={{ width: "120px", height: "120px" }} />
                            {testReport?.allIndiaRank && testReport?.percentile && (
                                <div className="d-flex justify-content-around align-items-center mx-auto my-3 px-3 py-2" style={{ backgroundColor: "#ff5722", borderRadius: "5px", maxWidth: "500px", color: "white", fontSize: "18px", fontWeight: "600" }}>
                                    <span>All India Rank: {testReport?.allIndiaRank}</span>
                                    <span>Percentile: {testReport?.percentile}</span>
                                </div>
                            )}
                        </div>

                        {/* Score Cards */}
                        <div className="col-12 py-3" style={{ backgroundImage: "linear-gradient(to right, #fff7b1, #c4f7f0)" }}>
                            <div className="row g-3">
                                {[
                                    { label: "CORRECT", value: testReport?.correct_questions },
                                    { label: "INCORRECT", value: testReport?.wrongquestions },
                                    { label: "UNATTEMPTED", value: testReport?.totalquestion - testReport?.attempted_questions },
                                    { label: "POSITIVE MARKS", value: testReport?.testcorrectmarks?.toFixed(2) },
                                    { label: "NEGATIVE MARKS", value: testReport?.testwrongmarks?.toFixed(2) },
                                    {
                                        label: "NET SCORE",
                                        value: (testReport?.testcorrectmarks?.toFixed(2) - testReport?.testwrongmarks)?.toFixed(2),
                                        className: "bg-success text-white"
                                    }
                                ].map((item, i) => (
                                    <div className="col-lg-4 col-md-6 col-sm-12" key={i}>
                                        <div className={`text-center p-4 fs-6 shadow-sm ${item.className || 'bg-light text-dark'}`} style={{
                                            borderRadius: "12px",
                                            borderBottom: "3px solid green",
                                            fontWeight: "600",
                                            border: "1px solid #ccc",
                                        }}>
                                            <strong className='fs-4 d-block mb-2'>{item.value}</strong>
                                            <hr className='my-2' />
                                            {item.label}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Answer Sheet */}
                        <div className="col-12 my-3">
                            <div className="p-3 rounded shadow-sm">
                                <div className="row">
                                    {reportAnserSheet?.map((item, index) => (
                                        <div className="col-md-12 mb-3" key={index}>
                                            <div className="d-flex">
                                                <div className="rounded-circle text-white text-center me-2" style={{
                                                    backgroundColor: "#ff5722",
                                                    minWidth: "35px",
                                                    height: "35px",
                                                    lineHeight: "33px",
                                                    fontWeight: "600"
                                                }}>
                                                    {item?.questionNumber}
                                                </div>
                                                <div className="flex-grow-1" style={{ fontSize: "14px" }}>
                                                    <p className="">{renderhtml(item?.Question)}</p>
                                                    <ul className="list-unstyled ps-1 mb-2">
                                                        {["A", "B", "C", "D"].map((opt) => (
                                                            <li key={opt} className="d-flex align-items-start ">
                                                                <div style={{ width: "40px", fontWeight: "700" }}>({opt})</div>
                                                                <div className="">{renderhtml(item[`Option${opt}`])}</div>
                                                                <div className="ms-2">{selectedResponseIcon(opt, item.selectedOption, item.correctOption)}</div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <div className="">
                                                        <div className="bg-success text-white p-1 d-inline-block rounded">
                                                            Correct Answer: ({item.correctOption}) | Your Answer: ({item.selectedOption || "Not Selected"})
                                                        </div>
                                                        <div className="bg-orange text-white p-1 d-inline-block rounded ms-2">
                                                            <span>{item.Accuracy_Percentage} % marked correct{getQuestionDifficulty(item.Accuracy_Percentage)}</span>
                                                        </div>
                                                    </div>

                                                    {item?.Description && (
                                                        <div className="mt-3 p-3 rounded" style={{ backgroundColor: "#efe2db" }}>
                                                            <span className="fw-semibold">Explanation: </span>{renderhtml(item?.Description)}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Performance Evaluation */}
                        {/* <div className="col-12">
                            <div className="text-center bg-white p-4 my-2 rounded shadow-sm">
                                <h5 className="fw-bold mb-3">Performance Evaluation</h5>
                                <p style={{ fontSize: "18px" }}>Percentage Score: <strong>{percentile}%</strong></p>
                                <p style={{ fontSize: "18px" }}>Difficulty Level: <strong style={{ color: "green" }}>Easy</strong></p>
                            </div>
                        </div> */}

                        {/* Recommended Course */}
                        {(() => {
                            if (!courseRecommendation || !testReport?.totalquestion) return null;
                            const studentScore = Number((testReport?.testcorrectmarks || 0) - (testReport?.testwrongmarks || 0)) || 0;
                            const maxPossible = (testReport?.totalquestion || 1) * (testReport?.marks_per_question || 2);
                            const studentPercent = maxPossible > 0 ? Math.max(0, (studentScore / maxPossible) * 100) : 0;

                            return (
                                <div className="col-12">
                                    <div className="p-4 my-2 rounded shadow-sm" style={{ background: "#fff5f5", border: "1px solid #dc3545" }}>
                                        <h5 className="text-center fw-bold mb-3" style={{ color: "#333" }}>📚 Recommended Course</h5>
                                        <p className="text-center mb-3" style={{ fontSize: "14px", color: "#555" }}>
                                            Based on your current performance ({studentPercent.toFixed(1)}%), we recommend:
                                        </p>
                                        <a
                                            href={courseRecommendation.Link}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="d-block text-center py-3 px-4 fw-semibold rounded text-decoration-none"
                                            style={{
                                                background: "#fff5f5",
                                                border: "2px solid #dc3545",
                                                color: "#dc3545",
                                                fontSize: "18px",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {courseRecommendation.Title}
                                        </a>
                                    </div>
                                </div>
                            );
                        })()}

                        {/* Go Back Button */}
                        {
                            sectionWiseReport?.length > 0 &&
                            <div className="my-2">
                                <h4 className="text-center fw-bold mb-4  text-uppercase"
                                    style={{ letterSpacing: "2px", fontWeight: "700", color: "#6e1803ff" }}
                                >Segment Wise Report</h4>
                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                    {sectionWiseReport?.map((section, index) => (
                                        <SectionWiseReport key={index} section={section} />
                                    ))}
                                </div>
                            </div>
                        }
                        <div className="col-12 d-flex justify-content-center mt-3">
                            <Link
                                to="/StudentDashboard"
                                state={{ testData: testDetails, prePath: location.pathname }}
                                className="btn text-white px-4 py-2 rounded-pill"
                                style={{
                                    backgroundImage: "linear-gradient(to right, rgb(155, 0, 0), rgb(109, 7, 97))",
                                    fontWeight: "600"
                                }}
                            >
                                Go Back
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default UGC_Report;
